const updateStockIndicator = (stockIndicator, { quantity, available }) => {
  const raw = Number(quantity);
  const stock = Number.isFinite(raw) ? raw : 0;
  const threshold = Number(stockIndicator.dataset.lowStockThreshold);
  const purchasable = Boolean(available);

  stockIndicator.dataset.stockAmount = String(stock);

  const messages = {
    instock: stockIndicator.querySelector('[data-stock-in-stock]'),
    lowstock: stockIndicator.querySelector('[data-stock-low-stock]'),
    oos: stockIndicator.querySelector('[data-stock-out-of-stock]'),
  };

  const showMessage = (key) => {
    Object.entries(messages).forEach(([name, el]) => {
      if (!el) return;
      el.classList.toggle('hidden', name !== key);
    });
  };

  const textEl = stockIndicator.querySelector('[data-stock-in-stock-text]');
  const inStockText = stockIndicator.dataset.inStockLabel || '';
  const backorderText = stockIndicator.dataset.backorderLabel || inStockText;

  if (!purchasable) {
    showMessage('oos');
    return;
  }

  if (stock > 0 && stock < threshold) {
    showMessage('lowstock');
    return;
  }

  showMessage('instock');
  if (textEl) {
    textEl.textContent = stock <= 0 ? backorderText : inStockText;
  }
};

export default updateStockIndicator;